import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, Table, ConfigProvider } from 'antd';
import Heading from 'components/UI/Heading/Heading';
import { getLocalCurrency } from 'context/currency';
import { AuthContext } from 'context/AuthProvider';
import MoneyFormat from 'components/UI/Money/MoneyFormat';
import moment from 'moment';
import frFR from 'antd/es/locale/fr_FR';
import { dateToFr } from 'library/helpers/fonction';
import { TITRE_LISTE_LOCATION_AIRBNB } from 'library/helpers/constUtils';
import { ContactWrapper, AdressDetail } from './location.list.style';
import LocationListDetail from './location.list.detail';
import useMoreDataApi from 'library/hooks/useMoreDataApi';
import Loader from 'components/Loader/Loader';

const LocationAirBnbList = () => {

    const navigate = useNavigate();
    const [visibleModal, setVisibleModal] = useState(false);
    const [currency, setCurrency] = useState(getLocalCurrency());
    const [paramLocation, setParamLocation] = useState();
    const [loader, setLoader] = useState(false);
    const { user } = useContext(AuthContext);

    useEffect(() => {
        const curr = getLocalCurrency();
        if (curr) {
            setCurrency(getLocalCurrency());
        }
    }, [currency]);

    let url = [`${process.env.REACT_APP_API_URL}/liste-location-airbnb-par-client/${user.id}`];
    let { data, loading, error, errorMessage } = useMoreDataApi(url);

    const modalError = (title, message) => {
        Modal.error({
            title: title,
            content: message,
            onOk() {
                return;
            }
        });
    }

    if (error) {
        modalError(TITRE_LISTE_LOCATION_AIRBNB, 'Ooups ! Une erreur est survenue');
        return;
    }

    if (data && (data.length == 0 || loading)) {
        return <Loader />;
    }

    let location = data[0].value;

    const listStatut = [
        { text: 'En cours', value: 'EN_COURS' },
        { text: 'Validée', value: 'VALIDE' },
        { text: 'Annulée', value: 'ANNULE' },
        { text: 'Confirmée', value: 'CONFIRMEE' },
        { text: 'Terminée', value: 'EFFECTIVE' },
        { text: 'A rembourser', value: 'A_REMBOURSE' },
        { text: 'Remboursée', value: 'REMBOURSE' }
    ];

    const columns = [
        {
            title: 'Logement',
            dataIndex: 'nomLogement',
            key: 'nomLogement',
            align: "center"
        },
        {
            title: 'Quartier',
            dataIndex: 'quartier',
            key: 'quartier',
            align: "center"
        },
        {
            title: 'Nombre de personnes',
            dataIndex: 'nombrePersonnes',
            key: 'nombrePersonnes',
            align: "center"
        },
        {
            title: 'Nombre de chambres',
            dataIndex: 'nombreChambres',
            key: 'nombreChambres',
            align: "center"
        },
        {
            title: 'Total',
            dataIndex: 'montantAriary',
            key: 'montantAriary',
            align: "right",
            class: "nowrapCell",
            render: (val, record) => {
                return (currency === '€'
                    ? <MoneyFormat value={record.montantEuro} suffix={` ${currency}`} />
                    : <MoneyFormat value={record.montantAriary} suffix={` ${currency}`} />
                )
            }
        },
        {
            title: 'Statut',
            dataIndex: 'etat',
            key: 'etat',
            align: "center",
            filters: listStatut,
            render: (colData, record, colIndex) => {
                return (listStatut.map(({ value, text }) => {
                    return (
                        ((value === colData && value !== 'A_REMBOURSE') && <label>{text}</label>) ||
                        ((value === colData && value == 'A_REMBOURSE') && <label>{text} <br /> (Annulée: {dateToFr(record.dateAnnulation)})</label>)
                    )
                }
                ))
            },
            onFilter: (value, record) => {
                return (record.etat) === (value)
            }
        },
        {
            title: `Date d'arrivée`,
            dataIndex: 'dateDebut',
            key: 'dateDebut',
            align: "right",
            render: (value) => new Date(value).toLocaleDateString('fr-FR')
        },
        {
            title: `Date de départ`,
            dataIndex: 'dateFin',
            key: 'dateFin',
            align: "right",
            render: (value) => new Date(value).toLocaleDateString('fr-FR')
        }
    ];

    const handleCancel = () => {
        setVisibleModal(false);
    };

    const handelRowClick = (record) => {
        if (!record) {
            return null;
        }
        setParamLocation(record, currency);
        setVisibleModal(true);
    }
    return (
        <>
            {loader ? <Loader /> : null}
           
            <AdressDetail>
                <ConfigProvider locale={frFR}>
                    <Table className='table-overflow-x' rowClassName='row-cursor-pointer' style={{ width: "100%" }} pagination={true} dataSource={location} rowKey="id"
                        columns={columns} onRow={(record, index) => ({
                            onClick: () => handelRowClick(record, index),
                        })}>
                    </Table>
                </ConfigProvider>
            </AdressDetail>
            <Modal
                title="Ma location saisonnière"
                open={visibleModal}
                onCancel={handleCancel}
                footer={null}
                style={{ 'width': '50%' }}
                width="650px"
            >
                <LocationListDetail
                    param={paramLocation}
                    currency={currency}
                />
            </Modal>

        </>
    );
};

export default LocationAirBnbList;